import { ERROR } from '../../../constants/routes';
import { Base64 } from 'js-base64';

export const generateClassroomCorrectionViewerPayload = (assignment, status) => {
    if (!status?.id) {
        return null;
    }

    const payload = {
        googleCourseWorkId: assignment.googleCourseWorkId,
        bookId: assignment.bookInfo ? assignment.bookInfo.bookId : -1,
        originalId: assignment.homeworkId,
        source: assignment.source,
        profile: {
            statusId: status.id,
            time: assignment.profile.time,
        },
        isTerminationTracked: true,
    };

    return Base64.encode(JSON.stringify(payload));
};

export const clearAndRedirect = (history, path = ERROR) => {
    sessionStorage.clear();
    setTimeout(history, 0, path, { replace: true });
};
